import React from 'react';

const ForuZero = () => {
    return (
        <img className='loading' src={require("../asset/noResFound.png")} alt="result not found page" />
    );
};

export default ForuZero;